/*
* 一、使用场景
*   1.js语法的全场景

* 二、使用示例
*   1. 触发funcName监听
      eventBus.emit('funcName',data)
*   2. 添加funcName监听
      eventBus.addListener('funcName',(data) => { ... })
*   3. 移除funcName监听
      eventBus.removeListener('funcName', Function)
*/

class EventBus {

  constructor() {
    this.events = this.events || {};
    this.emit = EventBus.prototype.emit;
    this.addListener = EventBus.prototype.addListener;
    this.removeListener = EventBus.prototype.removeListener;
  }
}

EventBus.prototype.emit = function (type, ...args) {
  if (typeof type !== 'string') {
    return;
  }
  const e = this.events[type];
  if (!e) {
    return;
  }
  if (Array.isArray(e)) {
    for (let i = 0; i < e.length; i += 1) {
      e[i].apply(this, args);
    }
  } else {
    e[0].apply(this, args);
  }
};

EventBus.prototype.addListener = function (type, fun) {
  if (typeof type !== 'string' || typeof fun !== 'function') {
    return;
  }
  const e = this.events[type];
  if (!e) {
    this.events[type] = [fun];
  } else {
    e.push(fun);
  }
};

EventBus.prototype.removeListener = function (type, fun) {
  if (typeof type !== 'string' || typeof fun !== 'function') {
    return;
  }
  const e = this.events[type];
  if (e) {
    const index = e.indexOf(fun)
    e.splice(index, 1)
    this.events[type] = e && e.length !== 0 ? e : undefined;
  }
}

export default new EventBus();
